export default __webpack_public_path__ + "static/media/gallery9.4f522e14.jpg";